import { Select } from "element-ui";

export const tableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    refreshBtn: true,
    columnBtn: false,
    menu:false,
    page:false,
    column: [
    {
      label: '话题',
      prop: 'tagName',
      span: 24,
    },
    {
        label: '时间',
        prop: 'date',
        span: 24,
    },
    {
        label: '帖子量',
        prop: 'totalPostCount',
        span: 24,
    }]
}